const ProductSpecification = ({
  productOptions
}) => {
  return <div className="border-productDetails-textBorder border" data-sentry-component="ProductSpecification" data-sentry-source-file="ProductSpecification.jsx">
      {productOptions?.map(option => <div key={option.name} className="border-productDetails-textBorder text-productDetails-description grid grid-cols-2 border-b text-sm font-medium last:border-none">
          <div className="border-productDetails-textBorder bg-productDetails-textBg border-r p-3">
            {option.name}
          </div>
          <div className="p-3">
            {option?.values?.map(value => value.name).join(", ")}
          </div>
        </div>)}
    </div>;
};
export default ProductSpecification;